import React from "react";
import data from "../../json/ProjectManagement/projectmanagement.json";

const Projectmanagement = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="2xl:container p-4 lg:p-0 lg:px-20 flex flex-col lg:flex-row gap-[32px] lg:gap-[64px]">
        <div className="w-full lg:w-[40%]">
          <img
            src={
              process.env.PUBLIC_URL + "/images/Projectmanagement/pgmgtbg.svg"
            }
            alt="project_illustration"
          />
        </div>
        <div className="w-ful lg:w-[60%] lg:mt-[76px]">
          <div className="flex flex-col">
            <h1 className="text-28 md:text-32 lg:text-40">{data.Title}</h1>
            <div className="flex flex-col gap-3 mt-4 text-approachblk text-center lg:text-left">
              <p className="text-base md:text-18">{data.para1}</p>
              <p className="text-base md:text-18">{data.para2}</p>
              <p className="text-base md:text-18">{data.para3}</p>
            </div>
            <div className="w-full flex flex-wrap gap-8 mt-14 justify-left">
              {data.list.map((item, i) => (
                <div className="lg:h-[52px] h-[36px] w-[40vw] lg:w-[14.714vw] max-w-[200px] rounded-full flex items-center justify-center gap-3 border-[1px] border-DFDCD8 p-4">
                  <div>
                    <img
                      className="mx-auto my-auto"
                      src={process.env.PUBLIC_URL + item.logo}
                      alt=".logo"
                    />
                  </div>
                  <p className="">{item.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projectmanagement;
